const findUserLang = (storeID: string, storeLocale: string): string => {
  switch (storeID) {
    case '4':
      return 'da-DK'
    case '12':
      return 'nl-BE'
    case '18':
      return 'de-DE'
    case '20':
      return 'de-CH'
    case '31':
      return 'en-US'
    default:
      return storeLocale
  }
}

const formatNumber = (
  storeID: string,
  storeLocale: string,
  number: number,
  decimals?: number,
): string => {
  let decimalsToUse = decimals
  if (!decimalsToUse) {
    decimalsToUse = number % 1 > 0 ? 2 : 0
  }

  const userLang = findUserLang(storeID, storeLocale)
  return parseFloat(number.toFixed(decimalsToUse)).toLocaleString(userLang, {
    minimumFractionDigits: decimalsToUse,
  })
}

export const formatPrice = (
  storeID: string,
  storeLocale: string,
  price: number,
  decimals?: number,
): string => {
  const formattedNumber = formatNumber(storeID, storeLocale, price, decimals)

  switch (storeID) {
    case '1':
    case '3':
    case '4':
      return `${formattedNumber} kr`
    case '5':
    case '15':
    case '18':
    case '21':
      return `€${formattedNumber}`
    case '6':
    case '7':
    case '10':
    case '11':
    case '12':
    case '14':
    case '23':
    case '24':
    case '26':
      return `${formattedNumber} €`
    case '8':
      return `£${formattedNumber}`
    case '9':
      return `${formattedNumber} Kč`
    case '16':
      return `${formattedNumber} zł`
    case '17':
      return `${formattedNumber} Ft`
    case '19':
    case '20':
      return `CHF ${formattedNumber}`
    case '22':
      return `${formattedNumber} лв.`
    case '25':
      return `${formattedNumber} Lei`
    case '27':
    case '28':
    case '32':
    case '36':
      return `$${formattedNumber}`
    case '29':
      return `SGD ${formattedNumber}`
    case '31':
      return `R ${formattedNumber}`
    case '33':
      return `CAD $${formattedNumber}`
    case '34':
      return `${formattedNumber} $ CAD`
    default:
      return formattedNumber
  }
}

